import * as React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { actionCreators } from './actions';
import { CaseDraftInfoState } from './types';
import { insertLink } from './insert-link';
import styles from './case-draft-info-panel.scss';

export interface CaseDraftInfoPanelOwnProps {
  textTitle?: string;
  textSubtitle: string;
  textCase: string;
  textCases: string;
}

type CaseDraftInfoPanelProps = CaseDraftInfoState & CaseDraftInfoPanelOwnProps & typeof actionCreators;

const CaseDraftInfoPanelComponent: React.FC<CaseDraftInfoPanelProps> & { statePath?: string } = ({
  textTitle = '',
  textSubtitle,
  textCase,
  textCases,
  count,
  fetching,
  loadDraftsCount
}) => {
  useEffect(() => {
    loadDraftsCount();
  }, []);

  if (fetching || !count) {
    return null;
  }

  const formattedLink = replaceTemplateString(count === 1 ? textCase : textCases, count);
  const link = <Link to={routeConstants.myCaseDraftsView}>{formattedLink}</Link>;

  const description = <div className={styles.description}>
    {insertLink(textSubtitle, [link])}
  </div>;

  if(!textTitle) {
    return description;
  }

  return <div className={styles.caseDraftContainer}>
    <div className={`row ${styles.caseDraftContainerRow}`}>
      <div className={`col-12 ${styles.colContainer}`}>
        <div>
          <h1>{textTitle}</h1>
          {description}
        </div>
      </div>
    </div>
  </div>;
};

CaseDraftInfoPanelComponent.statePath = STATE.caseDraftInfo;

export const CaseDraftInfoPanel = containerFactory<CaseDraftInfoPanelOwnProps>(
  CaseDraftInfoPanelComponent,
  actionCreators,
  null,
  null
);
